import Input from './Input';
import GeneratePassword from './GeneratePassword/GeneratePassword';

Input.GeneratePassword = GeneratePassword;

export default Input;
